;(function (angular) {
  'use strict'

  angular
    .module('kilo.routes.preferences', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  function RouteConfigurator ($stateProvider) {
    var preferencesState = {
      name: 'preferences',
      url: '/preferences',
      resolve: {
        tabIndex: ['$stateParams', '$location', function ($stateParams, $location) {
          const search = $location.search()
          let parsed
          try {
            parsed = parseInt(search?.tabIndex || 0, 10)
          } catch (e) {
            parsed = 0
          }
          return $stateParams.tabIndex || parsed
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/preferences/preferences.template.html',
          controller: 'PreferencesController',
          controllerAs: 'prefs'
        }
      },
      params: {
        tabIndex: 0
      },
      ncyBreadcrumb: {
        label: 'Préférences'
      }
    }

    $stateProvider.state(preferencesState)
  }
})(window.angular)
